var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_771_1075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.699219,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_771_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3907 11.5645V9.68953H23.1601V11.5645H12.3907ZM12.3907 15.1705V13.2955H23.1601V15.1705H12.3907ZM15.8041 27.5742H8.40039C7.52706 27.5742 6.78789 27.2717 6.18289 26.6667C5.57789 26.0617 5.27539 25.3226 5.27539 24.4492V20.8436H9.02539V3.82422H26.5254V14.3964C26.2048 14.3787 25.8871 14.3983 25.5723 14.4552C25.2573 14.512 24.95 14.6062 24.6504 14.7377V5.69922H10.9004V20.8436H17.9916L16.1166 22.7183H7.15039V24.4492C7.15039 24.8034 7.27018 25.1003 7.50977 25.3398C7.74935 25.5794 8.04622 25.6992 8.40039 25.6992H15.8041V27.5742ZM18.5448 27.5742V24.2714L25.3307 17.5164C25.4861 17.361 25.6543 17.2516 25.8354 17.1883C26.0164 17.1252 26.1976 17.0936 26.3788 17.0936C26.5726 17.0936 26.7621 17.1304 26.9473 17.2039C27.1323 17.2777 27.2985 17.3883 27.446 17.5358L28.6023 18.7039C28.7369 18.8595 28.841 19.0279 28.9148 19.2089C28.9885 19.3899 29.0254 19.571 29.0254 19.752C29.0254 19.9331 28.9917 20.1173 28.9245 20.3048C28.8572 20.4923 28.7498 20.6638 28.6023 20.8192L21.8476 27.5742H18.5448ZM20.0351 26.0839H21.2226L25.2801 22.0067L24.7057 21.413L24.1238 20.8267L20.0351 24.8964V26.0839ZM24.7057 21.413L24.1238 20.8267L25.2801 22.0067L24.7057 21.413Z",
    fill: "#00DD0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.da1de67e81110f7afcec80c8d7d2a619.svg";
export { ForwardRef as ReactComponent };